import PageData from "../../common/ts/PageData";
import {EventBus} from "../../common/ts/events/EventBus";
import {
    FullPageModalOpenEvent,
    PhoneTrackingModalOpenEvent,
    PhoneTrackingModalOpenEventPayload,
    WhitelabelEvent
} from "../../common/ts/events/Events";
import AdFormService from "../../common/ts/services/AdFormService";
import {Section} from "../../common/ts/services/Section";

export default class HipflatPhoneTracking {

    private readonly pageData: PageData;
    private readonly phoneTrackingModalId: string = 'phone-tracking-modal';

    private constructor(pageData: PageData) {
        this.pageData = pageData;
        this.setupEventListeners();
    }

    static init = (pageData: PageData) => {
        return new HipflatPhoneTracking(pageData);
    }

    setupEventListeners = () => {
        const eventBus: EventBus = EventBus.getInstance();
        eventBus.subscribe(PhoneTrackingModalOpenEvent.TYPE, (phoneTrackingModalOpenEvent: WhitelabelEvent) => {
            this.onModalOpen(phoneTrackingModalOpenEvent, eventBus);
        });
    }

    private onModalOpen(phoneTrackingModalOpenEvent: WhitelabelEvent, eventBus: EventBus) {
        const adFormService = new AdFormService();
        const payload: PhoneTrackingModalOpenEventPayload = (phoneTrackingModalOpenEvent as PhoneTrackingModalOpenEvent).payload;
        const phoneElements = document.getElementsByClassName("js-phone-tracking-phone");
        const requestedPhone = payload.requestedPhone;
        if (phoneElements.length > 0) {
            phoneElements[0].innerHTML = requestedPhone
        }
        const extensionElements = document.getElementsByClassName("js-phone-tracking-display-extension");
        if (extensionElements.length > 0) {
            extensionElements[0].innerHTML = payload.requestedPhoneExtension;
        } else {
            const textElements = document.getElementsByClassName("js-phone-tracking-text")
            if (requestedPhone && textElements.length > 0) {
                const textElement = textElements[0] as HTMLElement
                textElement.innerHTML = <string>textElement.dataset.textmessage;
                textElement.innerHTML = textElement.innerHTML.replace('XXXX*', requestedPhone.split(',')[1]);
            }
            const phoneLinkElements = document.getElementsByClassName("js-phone-tracking-phone-redirect")
            if (requestedPhone && phoneLinkElements.length > 0) {
                const phoneLinkElement = phoneLinkElements[0];
                phoneLinkElement.setAttribute('href', `tel:${requestedPhone}`);
                phoneLinkElement.addEventListener('click', () => {
                    adFormService.applyImpression(this.pageData, Section.SECTION_ADPAGE_CALL, 2)
                });
            }
        }
        adFormService.applyImpression(this.pageData, Section.SECTION_ADPAGE_CALL, 1);
        eventBus.emit(new FullPageModalOpenEvent({id: this.phoneTrackingModalId}));
    }
};
